import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import baseUrl from 'Base_Url/baseUrl';
import {
  Box,
  Heading,
  Input,
  InputGroup,
  InputLeftElement,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  useDisclosure,
  Icon,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useColorModeValue,
  useToast,
  Flex,
  Tooltip,
  IconButton,
  Skeleton,
  CloseButton,
} from '@chakra-ui/react';
import { SearchIcon, AddIcon } from '@chakra-ui/icons';
import { FaBuilding } from 'react-icons/fa';
import { FaHome } from 'react-icons/fa';
import Select from 'react-select';
import { useColorMode } from '@chakra-ui/react';
import { RiDeleteBin2Line } from 'react-icons/ri';
import Swal from 'sweetalert2';
import { MdEditSquare } from 'react-icons/md';

const VillageSection = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [newVillage, setNewVillage] = useState('');
  const [divisionId, setDivisionId] = useState('');
  const [districtId, setDistrictId] = useState('');
  const [tahsilId, setTahsilId] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [villages, setVillages] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [tahsils, setTahsils] = useState([]);
  const toast = useToast();
  const token = localStorage.getItem('token');
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [modalDivisionId, setModalDivisionId] = useState('');
  const [modalDistrictId, setModalDistrictId] = useState('');
  const [modalTahsilId, setModalTahsilId] = useState('');
  const [modalDistricts, setModalDistricts] = useState([]);
  const [modalTahsils, setModalTahsils] = useState([]);
  const [villageLoading, setVillageLoading] = useState(false);
  const [undoVillage, setUndoVillage] = useState(null);
  const deleteTimeouts = useRef({});
  const { colorMode } = useColorMode();

  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const selectStyles = {
    control: (base) => ({
      ...base,
      background: colorMode === 'dark' ? '#2D3748' : '#fff',
      color: colorMode === 'dark' ? '#fff' : '#000',
      borderColor: colorMode === 'dark' ? '#4A5568' : '#CBD5E0',
      minHeight: '32px',
      height: '32px',
      fontSize: '0.875rem',
    }),
    menu: (base) => ({
      ...base,
      background: colorMode === 'dark' ? '#1A202C' : '#fff',
      color: colorMode === 'dark' ? '#fff' : '#000',
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? colorMode === 'dark'
          ? '#2B6CB0'
          : '#3182CE'
        : state.isFocused
          ? colorMode === 'dark'
            ? '#2D3748'
            : '#E2E8F0'
          : 'transparent',
      color: colorMode === 'dark' ? '#fff' : '#000',
    }),
    singleValue: (base) => ({
      ...base,
      color: colorMode === 'dark' ? '#fff' : '#000',
    }),
    input: (base) => ({
      ...base,
      color: colorMode === 'dark' ? '#fff' : '#000',
    }),
  };

  const divisionOptions = divisions.map((div) => ({
    value: div._id,
    label: div.name,
  }));

  const districtOptions = districts.map((dis) => ({
    value: dis._id,
    label: dis.name,
  }));

  const tahsilOptions = tahsils.map((tahsil) => ({
    value: tahsil._id,
    label: tahsil.name,
  }));

  const fetchDivisions = useCallback(async () => {
    try {
      const res = await axios.get(`${baseUrl}/master/all-divisions`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const divisionsArray = res.data?.data?.data || [];
      // divisionsArray.sort((a, b) => a.name.localeCompare(b.name));
      setDivisions(divisionsArray);
    } catch {
      toast({
        title: 'Error fetching divisions',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }, [token, toast]);


  const fetchDistricts = useCallback(async () => {
    try {
      const res = await axios.get(`${baseUrl}/master/all-districts`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const districtsArray = res.data?.data?.data || [];
      setDistricts(districtsArray);

      if (districtsArray.length > 0) {
        const firstDistrictId = districtsArray[0]._id;
        setDistrictId(firstDistrictId);

        const tahsilRes = await axios.get(`${baseUrl}/master/all-tahsils`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { districtId: firstDistrictId },
        });
        const tahsilsArray = tahsilRes.data?.data?.data || [];
        setTahsils(tahsilsArray);

        if (tahsilsArray.length > 0) {
          setTahsilId(tahsilsArray[0]._id);
        }
      }
    } catch {
      toast({
        title: 'Error fetching districts/tahsils',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }, [token, toast]);



  const fetchVillages = useCallback(
    async (search = '') => {
      setVillageLoading(true);
      try {
        const res = await axios.get(`${baseUrl}/master/all-villages`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            search,
            districtId: districtId || undefined,
            tahsilId: tahsilId || undefined,
          },
        });

        let villagesArray = res.data?.data?.data || [];

        if (districtId && tahsilId) {
          villagesArray = villagesArray.filter(
            (village) =>
              village.district?._id === districtId &&
              village.tahsil?._id === tahsilId,
          );
        } else if (districtId) {
          villagesArray = villagesArray.filter(
            (village) => village.district?._id === districtId,
          );
        } else if (tahsilId) {
          villagesArray = villagesArray.filter(
            (village) => village.tahsil?._id === tahsilId,
          );
        }

        setVillages(villagesArray);
      } catch {
        toast({
          title: 'Error fetching villages',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      } finally {
        setVillageLoading(false);
      }
    },
    [token, toast, districtId, tahsilId],
  );

  useEffect(() => {
    if (districtId) {
      localStorage.setItem('selectedDistrictId', districtId);
    }
  }, [districtId]);

  useEffect(() => {
    if (tahsilId) {
      localStorage.setItem('selectedTahsilId', tahsilId);
    }
  }, [tahsilId]);

  useEffect(() => {
    fetchDivisions();
    fetchDistricts();
    // fetchTahsils();
  }, [fetchDivisions, fetchDistricts]);

  useEffect(() => {
    if (districtId && tahsilId) {
      fetchVillages(searchInput);
    }
  }, [searchInput, districtId, tahsilId, fetchVillages]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchInput !== '') setCurrentPage(1);
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [searchInput]);

  const handleModalDivisionChange = async (selectedOption) => {
    const divisionId = selectedOption?.value || '';
    setModalDivisionId(divisionId);
    setModalDistrictId('');
    setModalTahsilId('');
    setModalDistricts([]);
    setModalTahsils([]);
    if (divisionId) {
      try {
        const res = await axios.get(`${baseUrl}/master/all-districts`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { divisionId },
        });
        setModalDistricts(res.data?.data?.data || []);
      } catch {
        toast({
          title: 'Error fetching modal districts',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    }
  };

  const handleModalDistrictChange = async (selectedOption) => {
    const districtId = selectedOption?.value || '';
    setModalDistrictId(districtId);
    setModalTahsilId('');
    setModalTahsils([]);
    if (districtId) {
      try {
        const res = await axios.get(`${baseUrl}/master/all-tahsils`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { districtId },
        });
        setModalTahsils(res.data?.data?.data || []);
      } catch {
        toast({
          title: 'Error fetching modal tahsils',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    }
  };

  const handleSaveVillage = async () => {
    if (!newVillage.trim() || !modalDivisionId || !modalDistrictId || !modalTahsilId) {
      toast({
        title: 'Please provide all required fields',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    try {
      if (isEditing && editingId) {
        await axios.put(
          `${baseUrl}/master/edit-village/${editingId}`,
          {
            name: newVillage.trim(),
            division: modalDivisionId,
            district: modalDistrictId,
            tahsil: modalTahsilId,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        toast({
          title: 'Village updated successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        await axios.post(
          `${baseUrl}/master/add-village`,
          {
            name: newVillage.trim(),
            division: modalDivisionId,
            district: modalDistrictId,
            tahsil: modalTahsilId,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );
        toast({
          title: 'Village added successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      }

      resetModalFields();
      onClose();
      fetchVillages(searchInput);
    } catch (err) {
      toast({
        title: isEditing ? 'Failed to update village' : 'Failed to add village',
        description: err.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = async (village = null) => {
    fetchDivisions();

    if (village) {
      setIsEditing(true);
      setEditingId(village._id);
      setNewVillage(village.name);

      // Set division, district, tahsil IDs
      const divId = village.division?._id || '';
      const disId = village.district?._id || '';
      const tahId = village.tahsil?._id || '';

      setModalDivisionId(divId);
      setModalDistrictId(disId);
      setModalTahsilId(tahId);

      // 🔹 fetch districts for that division
      if (divId) {
        try {
          const res = await axios.get(`${baseUrl}/master/all-districts`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { divisionId: divId },
          });
          const fetchedDistricts = res.data?.data?.data || [];
          setModalDistricts(fetchedDistricts);

          // 🔹 fetch tahsils for that district
          if (disId) {
            const res2 = await axios.get(`${baseUrl}/master/all-tahsils`, {
              headers: { Authorization: `Bearer ${token}` },
              params: { districtId: disId },
            });
            setModalTahsils(res2.data?.data?.data || []);
          }
        } catch (err) {
          toast({
            title: 'Error preloading district/tahsil',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
        }
      }
    } else {
      resetModalFields();
      setIsEditing(false);
      setEditingId(null);
    }

    onOpen();
  };

  const handleDistrictFilterChange = async (selectedOption) => {
    const selectedDistrictId = selectedOption?.value || '';
    setDistrictId(selectedDistrictId);
    setTahsilId('');
    setTahsils([]);
    if (selectedDistrictId) {
      try {
        const res = await axios.get(`${baseUrl}/master/all-tahsils`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { districtId: selectedDistrictId },
        });
        setTahsils(res.data?.data?.data || []);
      } catch {
        toast({
          title: 'Error fetching tahsils for selected district',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    }
  };

  const resetModalFields = () => {
    setNewVillage('');
    setModalDivisionId('');
    setModalDistrictId('');
    setModalTahsilId('');
    setModalDistricts([]);
    setModalTahsils([]);
  };

  const handleDeleteVillages = useCallback(
    (id) => {
      const villageToDelete = villages.find((v) => v._id === id);

      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this Village!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1f580cff',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.isConfirmed) {
          setVillages((prev) => prev.filter((v) => v._id !== id));
          setUndoVillage(villageToDelete);

          const toastId = `delete-toast-${id}`;

          toast({
            id: toastId,
            position: 'bottom-left',
            duration: 5000,
            render: ({ onClose }) => (
              <Flex
                align="center"
                justify="space-between"
                p={3}
                bg="gray.700"
                color="white"
                borderRadius="md"
                boxShadow="lg"
              >
                <Text fontSize="sm" noOfLines={1} mr={3}>
                  "{villageToDelete?.name}" deleted
                </Text>
                <Button
                  variant="ghost"
                  colorScheme="blue"
                  size="sm"
                  onClick={() => {
                    clearTimeout(deleteTimeouts.current[id]);
                    delete deleteTimeouts.current[id];

                    setVillages((prev) =>
                      [...prev, villageToDelete].sort((a, b) =>
                        a.name.localeCompare(b.name),
                      ),
                    );
                    setUndoVillage(null);
                    onClose();
                  }}
                >
                  Undo
                </Button>
                <CloseButton onClick={onClose} color="whiteAlpha.800" />
              </Flex>
            ),
          });

          deleteTimeouts.current[id] = setTimeout(async () => {
            try {
              await axios.delete(`${baseUrl}/master/delete-village/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
              });
              setUndoVillage(null);
            } catch (error) {
              toast({
                title: 'Error deleting Village',
                status: 'error',
                duration: 3000,
                isClosable: true,
              });
            }
          }, 5000);
        }
      });
    },
    [token, toast, villages],
  );

  useEffect(() => {
    return () => {
      Object.values(deleteTimeouts.current).forEach(clearTimeout);
    };
  }, []);

  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const headerBg = useColorModeValue('#f9f9f9', 'gray.700');
  const rowHoverBg = useColorModeValue('#f1f5f9', 'gray.600');
  const boxBg = useColorModeValue('white', 'gray.900');
  const modalBg = useColorModeValue('white', 'gray.800');
  const modalFooterBg = useColorModeValue('gray.50', 'gray.700');
  const modalFooterBorder = useColorModeValue('gray.200', 'gray.600');
  const headingColor = useColorModeValue('blue.800', 'blue.200');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const inputTextColor = useColorModeValue('gray.800', 'white');
  const boxShadow = useColorModeValue('md', 'dark-lg');

  return (
    <Box
      p={4}
      shadow={boxShadow}
      borderRadius="md"
      bg={boxBg}
      borderColor={borderColor}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Flex align="center" gap={2}>
          <Icon as={FaHome} boxSize={5} color="blue.500" />
          <Heading size="md">Villages</Heading>
        </Flex>

        <Tooltip label="Add Village" hasArrow>
          <IconButton
            colorScheme="blue"
            size="sm"
            onClick={onOpen}
            icon={<AddIcon />}
            aria-label="Add Village"
            rounded="full"
            _hover={{ bg: 'blue.600' }}
          />
        </Tooltip>
      </Box>

      <Flex mb={4} gap={4} wrap="wrap">
        <InputGroup flex="1" size="sm" w={'25%'}>
          <InputLeftElement pointerEvents="none">
            <SearchIcon color="gray.400" />
          </InputLeftElement>
          <Input
            placeholder="Search Village"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            color={inputTextColor}
          />
        </InputGroup>

        <Select
          options={districtOptions}
          placeholder="Select District"
          value={
            districtId
              ? {
                value: districtId,
                label: `Districts: ${districtOptions.find((d) => d.value === districtId)
                  ?.label || ''
                  }`,
              }
              : null
          }
          onChange={handleDistrictFilterChange}
          styles={selectStyles}
        />

        <Select
          options={tahsilOptions}
          placeholder="Select Tahsil"
          value={
            tahsilId
              ? {
                value: tahsilId,
                label: `Tahsils: ${tahsilOptions.find((t) => t.value === tahsilId)?.label || ''
                  }`,
              }
              : null
          }
          onChange={(selectedOption) =>
            setTahsilId(selectedOption?.value || '')
          }
          styles={selectStyles}
        />
      </Flex>

      <Box
        bg={useColorModeValue('white', 'gray.800')}
        rounded="lg"
        overflow="auto"
        maxH="260px"
        css={{
          '&::-webkit-scrollbar': {
            width: '6px',
            height: '6px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#CBD5E0',
            borderRadius: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
        }}
      >
        <Table size={'sm'} variant="simple" minW="600px">
          <Thead
            position="sticky"
            top={0}
            bgGradient="linear(to-r, blue.400, green.400)"
          >
            <Tr>
              <Th textAlign="center" fontSize="xs" color="white">
                Sr.No.
              </Th>
              <Th fontSize="xs" color="white">
                Village
              </Th>
              <Th fontSize="xs" color="white">
                Tahsil
              </Th>
              <Th fontSize="xs" color="white">
                District
              </Th>
              <Th fontSize="xs" color="white">
                Division
              </Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {villageLoading ? (
              Array.from({ length: 5 }).map((_, i) => (
                <Tr key={i}>
                  <Td textAlign="center">
                    <Skeleton height="10px" />
                  </Td>
                  <Td>
                    <Skeleton height="10px" />
                  </Td>
                  <Td>
                    <Skeleton height="10px" />
                  </Td>
                  <Td>
                    <Skeleton height="10px" />
                  </Td>
                  <Td>
                    <Skeleton height="10px" />
                  </Td>
                  <Td>
                    <Skeleton height="10px" />
                  </Td>
                </Tr>
              ))
            ) : villages.length === 0 ? (
              <Tr>
                <Td colSpan={5} textAlign="center" py={6}>
                  <Text color={textColor}>No Villages Found</Text>
                </Td>
              </Tr>
            ) : (
              villages.map((village, index) => (
                <Tr key={village._id} _hover={{ bg: rowHoverBg }}>
                  <Td textAlign="center" fontSize={'12px'}>
                    {index + 1}
                  </Td>
                  <Td fontSize={'12px'}>{village.name.toUpperCase()}</Td>
                  <Td fontSize={'12px'}>
                    {village.tahsil?.name.toUpperCase()}
                  </Td>
                  <Td fontSize={'12px'}>
                    {village.district?.name.toUpperCase()}
                  </Td>
                  <Td fontSize={'12px'}>
                    {village.division?.name.toUpperCase()}
                  </Td>

                  <Td>
                    {/* <IconButton
                      icon={<RiDeleteBin2Line />}
                      aria-label="Delete"
                      variant="ghost"
                      size="sm"
                      color="red.500"
                      _hover={{ color: 'blue.600' }}
                      onClick={() => handleDeleteVillages(village._id)}
                    /> */}

                    {/* <IconButton
                      icon={<MdEditSquare />}
                      aria-label="Edit"
                      variant="solid"
                      size="sm"
                      colorScheme="blue"
                      isRound
                      onClick={() => handleOpenModal(village)}
                    /> */}

                    <IconButton
                        icon={<MdEditSquare />}
                        aria-label="Edit"
                        variant="ghost"        
                        size="sm"
                        color="blue.500"         
                        _hover={{ bg: 'blue.50', color: 'blue.600' }} 
                        onClick={() => handleOpenModal(village)}
                      />
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent rounded="lg">
          <Box bg="blue.600" py={1} px={2}>
            <ModalHeader
              fontSize="2xl"
              fontWeight="bold"
              color="white"
              textAlign="center"
            >
              <Icon as={AddIcon} mr={2} />
              {isEditing ? 'Edit Village' : 'Add New Village'}
            </ModalHeader>
            <ModalCloseButton color="white" />
          </Box>
          <ModalBody bg={modalBg} px={6} py={4}>
            <Text fontSize="lg" fontWeight="bold" color={headingColor} mb={4}>
              <Icon as={FaBuilding} mr={2} />
              Village Details
            </Text>

            <FormControl isRequired w={'100%'}>
              <FormLabel>Division</FormLabel>
              <Select
                options={divisionOptions}
                placeholder="Select Division"
                value={divisionOptions.find(
                  (option) => option.value === modalDivisionId,
                )}
                onChange={handleModalDivisionChange}
                styles={selectStyles}
              />
            </FormControl>

            <FormControl isRequired w={'100%'} mt={4}>
              <FormLabel>District</FormLabel>
              <Select
                options={modalDistricts.map((d) => ({
                  value: d._id,
                  label: d.name,
                }))}
                placeholder="Select District"
                value={
                  modalDistricts.find((d) => d._id === modalDistrictId)
                    ? {
                      value: modalDistrictId,
                      label: modalDistricts.find(
                        (d) => d._id === modalDistrictId,
                      )?.name,
                    }
                    : null
                }
                onChange={handleModalDistrictChange}
                isDisabled={!modalDivisionId}
                styles={selectStyles}
              />
            </FormControl>

            <FormControl isRequired w={'100%'} mt={4}>
              <FormLabel>Tahsil</FormLabel>
              <Select
                options={modalTahsils.map((t) => ({
                  value: t._id,
                  label: t.name,
                }))}
                placeholder="Select Tahsil"
                value={
                  modalTahsils.find((t) => t._id === modalTahsilId)
                    ? {
                      value: modalTahsilId,
                      label: modalTahsils.find((t) => t._id === modalTahsilId)
                        ?.name,
                    }
                    : null
                }
                onChange={(selectedOption) =>
                  setModalTahsilId(selectedOption?.value || '')
                }
                isDisabled={!modalDistrictId}
                styles={selectStyles}
              />
            </FormControl>

            <FormControl isRequired w={'100%'} mt={4}>
              <FormLabel>Village Name</FormLabel>
              <Input
                placeholder="Enter Village Name"
                value={newVillage}
                onChange={(e) => setNewVillage(e.target.value)}
                color={inputTextColor}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter bg={modalFooterBg} borderColor="gray.200">
            <Button variant="ghost" colorScheme="red" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              onClick={handleSaveVillage}
              isLoading={loading}
            >
              <Icon as={AddIcon} mr={2} />
              {isEditing ? 'Update Village' : 'Add Village'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default VillageSection;
